import _ from "lodash";
import moment from "moment";
import {
  SERVICE_TYPE,
  TGetServicesCollectionItem,
} from "../../../../../../api/service/service.types";
import {
  SERVICE_HOLDER_HOME_FEATURE_ELEVATOR,
  SERVICE_HOLDER_HOME_FEATURE_ADAPTED_BATHROOM,
  SERVICE_HOLDER_HOME_FEATURE_CRANE,
  SERVICE_HOLDER_HOME_FEATURE_CAMERAS,
  SERVICE_HOLDER_HOME_FEATURE_ARTICULATED_BED,
  SERVICE_HOLDER_HOME_FEATURE_PETS,
  SERVICE_HOLDER_HOME_FEATURE_CLEAN_SERVICE,
  SERVICE_HOLDER_HOME_FEATURE_TELE_ASSISTANCE,
} from "../../../../../../util/defaults/serviceHolder";
import { tasksList } from "../../../../../../util/defaults/tareas";
import { formatCurrency } from "../../../../../../util/formatNumbers";
import { TServiceEditValuationForm } from "./ServiceEditValuationForm";
import uuidv4 from "uuid/v4";

export const transformServiceToEditValuationFormData = (
  service: TGetServicesCollectionItem,
  regionOptions: { value: string; label: string }[],
  areaOptions: { value: string; label: string }[],
  familiarUnitOptions: { value: string; label: string }[],
  pathologyOptions: { value: string; label: string }[],
  speechOptions: { value: string; label: string }[],
  mobilityOptions: { value: string; label: string }[],
  emotionalStatusOptions: { value: string; label: string }[],
  careAdaptationOptions: { value: string; label: string }[],
  sleepQualityOptions: { value: string; label: string }[],
  toiletLevelOptions: { value: string; label: string }[],
  salaryTypeOptions: { value: string; label: string }[],
  officialDegreeOptions: { value: string; label: string }[],
  serviceHolderUserStatusOptions: { value: string; label: string }[],
  dependencyOptions: { value: string; label: string }[]
): TServiceEditValuationForm => {
  const values = {
    service_type: SERVICE_TYPE.SELECTION,
    service_holder_op: "new",
    service_holder_id: "",
    service_holder_crm_id: "",
    service_holder_crm_id_name: "",
    Usuarios_a_cuidar: "1",
    Unidad_de_convivencia: "",
    Direccion: "",
    Direccion_2: "",
    Ciudad: null,
    Codigo_postal: "",
    Region: null,
    Area: null,
    Latitud: undefined,
    Longitud: undefined,
    formatted_address: undefined,

    Estado_U1: null,
    Nombre_U1: "",
    Primer_apellido_U1: "",
    Segundo_apellido_U1: "",
    Fecha_de_nacimiento_U1: null,
    DNI_U1: "",
    DNI_U1_used_by: null,
    Grado_Ley_de_dependencia_U1: null,

    Patologias_U1: [],
    Comentarios_patologias_U1: "",
    Medicacion_U1: "",
    Dieta: "",
    Habla_expresion_U1: "",
    Peso_U1: "",
    Altura_U1: "",
    Movilidad_U1: [],
    Comentarios_movilidad_U1: "",

    Estado_emocional_y_caracter_U1: [],
    Adaptaci_n_de_cuidados_U1: "",
    Comentarios_estado_emocional_y_caracter_U1: "",
    Actividades_y_aficiones_U1: "",
    Calidad_del_sue_o_U1: null,
    Aseo_U1: [],
    Indicaciones_del_sueno_U1: "",
    Indicaciones_del_aseo_U1: "",

    Estado_U2: null,
    Nombre_U2: "",
    Primer_apellido_U2: "",
    Segundo_apellido_U2: "",
    Fecha_de_nacimiento_U2: null,
    DNI_U2: "",
    DNI_U2_used_by: null,
    Grado_Ley_de_dependencia_U2: null,

    Patologias_U2: [],
    Comentarios_patologias_U2: "",
    Medicacion_U2: "",
    Dieta_U2: "",
    Habla_expresion_U2: "",
    Peso_U2: "",
    Altura_U2: "",
    Movilidad_U2: [],
    Comentarios_movilidad_U2: "",

    Estado_emocional_y_caracter_U2: [],
    Adaptaci_n_de_cuidados_U2: "",
    Comentarios_estado_emocional_y_caracter_U2: "",
    Actividades_y_aficiones_U2: "",
    Calidad_del_sue_o_U2: null,
    Aseo_U2: [],
    Indicaciones_del_sueno_U2: "",
    Indicaciones_del_aseo_U2: "",

    Tipo_de_vivienda: "",
    home_elevator: false,
    home_adapted_bathroom: false,
    home_crane: false,
    home_cameras: false,
    home_articulated_bed: false,
    home_pets: false,
    home_clean_service: false,
    home_tele_asistance: false,
    Proveedor_de_Teleasistencia: "",
    Comunicacion_con_transporte_publico: "",

    Notas_coordinadora: "",

    Direccion_entrega_Cuideo_Asist_distinta_servicio: "No",
    Ciudad_entrega_Cuideo_Asist: "",
    Codigo_postal_entrega_Cuideo_Asist: "",
    Direccion_entrega_Cuideo_Asist: "",
    Region_entrega_Cuideo_Asist: null,
    Area_entrega_Cuideo_Asist: null,
    Latitud_entrega_Cuideo_Asist: undefined,
    Longitud_entrega_Cuideo_Asist: undefined,
    formatted_address_entrega_Cuideo_Asist: undefined,
    Inicio_de_servicio: null,

    Tareas_solicitadas: [],
    Rutinas: "",
    Sexo_trabajador: "",
    Otras_notas_valoracion: "",

    Horario_Servicio: "",
    Fecha_objetivo: null,
    Salario_Bruto: "",
    Fecha_objetivo_entrevistas: null,
    Tipo_de_salario: null,
    Horas_jornada_semanal: "",
    Descanso_semanal: "",
    Cl_usulas_especiales: "",
    Titulaci_n_oficial:
      officialDegreeOptions.find((option) => option.value === "No necesaria") ??
      null,

    Contactos: [],

    Lead_External_ID: null,
    Referente_B2B: null,

    re_send_valuation_summary: false,
  } as TServiceEditValuationForm;

  if (service) {
    if (!_.isEmpty(service.valuationData)) {
      return {
        ...values,
        ...service.valuationData,
      };
    }

    if (service.Tipo_de_Servicio) {
      values.service_type = service.Tipo_de_Servicio;
    }

    if (service.Usuario1?.id) {
      values.service_holder_op = "existing";
      values.service_holder_id = service.Usuario1.id;
    }
    if (service.Usuario1?.Name) {
      values.service_holder_crm_id_name = service.Usuario1.Name;
    }
    if (service.Usuario1?.zohoId) {
      values.service_holder_crm_id = service.Usuario1.zohoId;
    }

    if (service.Usuario1?.Usuarios_a_cuidar) {
      values.Usuarios_a_cuidar = (service.Usuario1.Usuarios_a_cuidar + "") as
        | "1"
        | "2";
    }

    if (service.Usuario1?.Unidad_de_convivencia) {
      values.Unidad_de_convivencia = service.Usuario1.Unidad_de_convivencia;
    }

    if (service.Usuario1?.Direccion) {
      values.Direccion = service.Usuario1.Direccion;
    }

    if (service.Usuario1?.Direccion_2) {
      values.Direccion_2 = service.Usuario1.Direccion_2;
    }

    if (service.Usuario1?.Ciudad) {
      values.Ciudad = {
        label: service.Usuario1.Ciudad,
        value: service.Usuario1.Ciudad,
      };
    }
    if (service.Usuario1?.Codigo_postal) {
      values.Codigo_postal = service.Usuario1.Codigo_postal;
    }
    if (service.Usuario1?.Region) {
      values.Region =
        regionOptions.find(
          (region) => region.value === service.Usuario1?.Region
        ) ?? null;
    }
    if (service.Usuario1?.Area) {
      values.Area =
        areaOptions.find((area) => area.value === service.Usuario1?.Area) ??
        null;
    }
    if (service.Usuario1?.Latitud) {
      values.Latitud = parseFloat(service.Usuario1.Latitud);
    }
    if (service.Usuario1?.Longitud) {
      values.Longitud = parseFloat(service.Usuario1.Longitud);
    }

    if (service.Usuario1?.Estado_U1) {
      values.Estado_U1 =
        serviceHolderUserStatusOptions.find(
          (status) => status.value === service.Usuario1?.Estado_U1
        ) ?? null;
    }
    if (service.Usuario1?.Nombre_U1) {
      values.Nombre_U1 = service.Usuario1.Nombre_U1;
    }
    if (service.Usuario1?.Primer_apellido_U1) {
      values.Primer_apellido_U1 = service.Usuario1.Primer_apellido_U1;
    }
    if (service.Usuario1?.Segundo_apellido_U1) {
      values.Segundo_apellido_U1 = service.Usuario1.Segundo_apellido_U1;
    }
    if (service.Usuario1?.Fecha_de_nacimiento_U1) {
      const date = moment(service.Usuario1.Fecha_de_nacimiento_U1);
      if (date.isValid()) {
        values.Fecha_de_nacimiento_U1 = date.toDate();
      }
    }
    if (service.Usuario1?.DNI_U1) {
      values.DNI_U1 = service.Usuario1.DNI_U1;
    }
    if (service.Usuario1?.Grado_Ley_de_dependencia_U1) {
      values.Grado_Ley_de_dependencia_U1 =
        dependencyOptions.find(
          (option) =>
            option.value === service.Usuario1?.Grado_Ley_de_dependencia_U1
        ) ?? null;
    }

    if (service.Usuario1?.Patologias_U1) {
      values.Patologias_U1 = pathologyOptions.filter(
        (pathology) =>
          !!service.Usuario1?.Patologias_U1?.find((sp) => {
            return sp === pathology.value;
          })
      );
    }
    if (service.Usuario1?.Comentarios_patologias_U1) {
      values.Comentarios_patologias_U1 =
        service.Usuario1.Comentarios_patologias_U1;
    }

    if (service.Usuario1?.Habla_expresion_U1) {
      values.Habla_expresion_U1 = service.Usuario1.Habla_expresion_U1;
    }
    if (service.Usuario1?.Medicacion_U1) {
      values.Medicacion_U1 = service.Usuario1.Medicacion_U1;
    }
    if (service.Usuario1?.Dieta) {
      values.Dieta = service.Usuario1.Dieta;
    }
    if (service.Usuario1?.Movilidad_U1) {
      values.Movilidad_U1 = mobilityOptions.filter(
        (mobilityOption) =>
          !!service.Usuario1?.Movilidad_U1?.find((mo) => {
            return mo === mobilityOption.value;
          })
      );
    }
    if (service.Usuario1?.Comentarios_movilidad_U1) {
      values.Comentarios_movilidad_U1 =
        service.Usuario1.Comentarios_movilidad_U1;
    }
    if (service.Usuario1?.Peso_U1) {
      values.Peso_U1 = service.Usuario1.Peso_U1 + "";
    }
    if (service.Usuario1?.Altura_U1) {
      values.Altura_U1 = service.Usuario1.Altura_U1 + "";
    }

    if (service.Usuario1?.Estado_emocional_y_caracter_U1) {
      values.Estado_emocional_y_caracter_U1 = emotionalStatusOptions.filter(
        (emotionalStatus) =>
          !!service.Usuario1?.Estado_emocional_y_caracter_U1?.find((s) => {
            return s === emotionalStatus.value;
          })
      );
    }
    if (service.Usuario1?.Adaptaci_n_de_cuidados_U1) {
      values.Adaptaci_n_de_cuidados_U1 =
        service.Usuario1.Adaptaci_n_de_cuidados_U1;
    }
    if (service.Usuario1?.Comentarios_estado_emocional_y_caracter_U1) {
      values.Comentarios_estado_emocional_y_caracter_U1 =
        service.Usuario1.Comentarios_estado_emocional_y_caracter_U1;
    }
    if (service.Usuario1?.Actividades_y_aficiones_U1) {
      values.Actividades_y_aficiones_U1 =
        service.Usuario1.Actividades_y_aficiones_U1;
    }

    if (service.Usuario1?.Calidad_del_sue_o_U1) {
      values.Calidad_del_sue_o_U1 =
        sleepQualityOptions.find(
          (option) => option.value === service.Usuario1?.Calidad_del_sue_o_U1
        ) ?? null;
    }
    if (service.Usuario1?.Indicaciones_del_sueno_U1) {
      values.Indicaciones_del_sueno_U1 =
        service.Usuario1.Indicaciones_del_sueno_U1;
    }
    if (service.Usuario1?.Aseo_U1) {
      values.Aseo_U1 = toiletLevelOptions.filter(
        (toiletOption) =>
          !!service.Usuario1?.Aseo_U1?.find((t) => t === toiletOption.value)
      );
    }
    if (service.Usuario1?.Indicaciones_del_aseo_U1) {
      values.Indicaciones_del_aseo_U1 =
        service.Usuario1.Indicaciones_del_aseo_U1;
    }

    // User 2
    if (service.Usuario1?.Estado_U2) {
      values.Estado_U2 =
        serviceHolderUserStatusOptions.find(
          (status) => status.value === service.Usuario1?.Estado_U2
        ) ?? null;
    }
    if (service.Usuario1?.Nombre_U2) {
      values.Nombre_U2 = service.Usuario1.Nombre_U2;
    }
    if (service.Usuario1?.Primer_apellido_U2) {
      values.Primer_apellido_U2 = service.Usuario1.Primer_apellido_U2;
    }
    if (service.Usuario1?.Segundo_apellido_U2) {
      values.Segundo_apellido_U2 = service.Usuario1.Segundo_apellido_U2;
    }
    if (service.Usuario1?.Fecha_de_nacimiento_U2) {
      const date = moment(service.Usuario1.Fecha_de_nacimiento_U2);
      if (date.isValid()) {
        values.Fecha_de_nacimiento_U2 = date.toDate();
      }
    }
    if (service.Usuario1?.DNI_U2) {
      values.DNI_U2 = service.Usuario1.DNI_U2;
    }
    if (service.Usuario1?.Grado_Ley_de_dependencia_U2) {
      values.Grado_Ley_de_dependencia_U2 =
        dependencyOptions.find(
          (option) =>
            option.value === service.Usuario1?.Grado_Ley_de_dependencia_U2
        ) ?? null;
    }

    if (service.Usuario1?.Patologias_U2) {
      values.Patologias_U2 = pathologyOptions.filter(
        (pathology) =>
          !!service.Usuario1?.Patologias_U2?.find((sp) => {
            return sp === pathology.value;
          })
      );
    }
    if (service.Usuario1?.Comentarios_patologias_U2) {
      values.Comentarios_patologias_U2 =
        service.Usuario1.Comentarios_patologias_U2;
    }

    if (service.Usuario1?.Habla_expresion_U2) {
      values.Habla_expresion_U2 = service.Usuario1.Habla_expresion_U2;
    }
    if (service.Usuario1?.Medicacion_U2) {
      values.Medicacion_U2 = service.Usuario1.Medicacion_U2;
    }
    if (service.Usuario1?.Dieta_U2) {
      values.Dieta_U2 = service.Usuario1.Dieta_U2;
    }
    if (service.Usuario1?.Movilidad_U2) {
      values.Movilidad_U2 = mobilityOptions.filter(
        (mobilityOption) =>
          !!service.Usuario1?.Movilidad_U2?.find((mo) => {
            return mo === mobilityOption.value;
          })
      );
    }
    if (service.Usuario1?.Comentarios_movilidad_U2) {
      values.Comentarios_movilidad_U2 =
        service.Usuario1.Comentarios_movilidad_U2;
    }
    if (service.Usuario1?.Peso_U2) {
      values.Peso_U2 = service.Usuario1.Peso_U2 + "";
    }
    if (service.Usuario1?.Altura_U2) {
      values.Altura_U2 = service.Usuario1.Altura_U2 + "";
    }

    if (service.Usuario1?.Estado_emocional_y_caracter_U2) {
      values.Estado_emocional_y_caracter_U2 = emotionalStatusOptions.filter(
        (emotionalStatus) =>
          !!service.Usuario1?.Estado_emocional_y_caracter_U2?.find((s) => {
            return s === emotionalStatus.value;
          })
      );
    }
    if (service.Usuario1?.Adaptaci_n_de_cuidados_U2) {
      values.Adaptaci_n_de_cuidados_U2 =
        service.Usuario1.Adaptaci_n_de_cuidados_U2;
    }
    if (service.Usuario1?.Comentarios_estado_emocional_y_caracter_U2) {
      values.Comentarios_estado_emocional_y_caracter_U2 =
        service.Usuario1.Comentarios_estado_emocional_y_caracter_U2;
    }
    if (service.Usuario1?.Actividades_y_aficiones_U2) {
      values.Actividades_y_aficiones_U2 =
        service.Usuario1.Actividades_y_aficiones_U2;
    }

    if (service.Usuario1?.Calidad_del_sue_o_U2) {
      values.Calidad_del_sue_o_U2 =
        sleepQualityOptions.find(
          (option) => option.value === service.Usuario1?.Calidad_del_sue_o_U2
        ) ?? null;
    }
    if (service.Usuario1?.Indicaciones_del_sueno_U2) {
      values.Indicaciones_del_sueno_U2 =
        service.Usuario1.Indicaciones_del_sueno_U2;
    }
    if (service.Usuario1?.Aseo_U2) {
      values.Aseo_U2 = toiletLevelOptions.filter(
        (toiletOption) =>
          !!service.Usuario1?.Aseo_U2?.find((t) => t === toiletOption.value)
      );
    }
    if (service.Usuario1?.Indicaciones_del_aseo_U2) {
      values.Indicaciones_del_aseo_U2 =
        service.Usuario1.Indicaciones_del_aseo_U2;
    }

    if (service.Usuario1?.Tipo_de_vivienda) {
      values.Tipo_de_vivienda = service.Usuario1.Tipo_de_vivienda;
    }
    if (service.Usuario1?.Caracteristicas_de_la_vivienda) {
      values.home_elevator =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_ELEVATOR
        );
      values.home_adapted_bathroom =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_ADAPTED_BATHROOM
        );
      values.home_crane =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_CRANE
        );
      values.home_cameras =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_CAMERAS
        );
      values.home_articulated_bed =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_ARTICULATED_BED
        );
      values.home_pets =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_PETS
        );
      values.home_clean_service =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_CLEAN_SERVICE
        );
      values.home_tele_asistance =
        service.Usuario1.Caracteristicas_de_la_vivienda.includes(
          SERVICE_HOLDER_HOME_FEATURE_TELE_ASSISTANCE
        );
    }
    if (service.Usuario1?.Proveedor_de_Teleasistencia) {
      values.Proveedor_de_Teleasistencia =
        service.Usuario1.Proveedor_de_Teleasistencia;
    }
    if (service.Usuario1?.Comunicacion_con_transporte_publico) {
      values.Comunicacion_con_transporte_publico =
        service.Usuario1.Comunicacion_con_transporte_publico;
    }

    if (service.Usuario1?.Notas_coordinadora) {
      values.Notas_coordinadora = service.Usuario1.Notas_coordinadora;
    }

    // Service
    if (service.Otras_notas_valoracion) {
      values.Otras_notas_valoracion = service.Otras_notas_valoracion;
    }

    if (service.Direccion_entrega_Cuideo_Asist_distinta_servicio) {
      values.Direccion_entrega_Cuideo_Asist_distinta_servicio =
        service.Direccion_entrega_Cuideo_Asist_distinta_servicio;
      if (values.Direccion_entrega_Cuideo_Asist_distinta_servicio === "Si") {
        if (service.Direccion_entrega_Cuideo_Asist) {
          values.Direccion_entrega_Cuideo_Asist =
            service.Direccion_entrega_Cuideo_Asist;
        }
        if (service.Ciudad_entrega_Cuideo_Asist) {
          values.Ciudad_entrega_Cuideo_Asist =
            service.Ciudad_entrega_Cuideo_Asist;
        }
        if (service.Codigo_postal_entrega_Cuideo_Asist) {
          values.Codigo_postal_entrega_Cuideo_Asist =
            service.Codigo_postal_entrega_Cuideo_Asist;
        }
        if (service.Latitud_entrega_Cuideo_Asist) {
          values.Latitud_entrega_Cuideo_Asist =
            service.Latitud_entrega_Cuideo_Asist;
        }
        if (service.Longitud_entrega_Cuideo_Asist) {
          values.Longitud_entrega_Cuideo_Asist =
            service.Longitud_entrega_Cuideo_Asist;
        }
        if (service.Region_entrega_Cuideo_Asist) {
          values.Region_entrega_Cuideo_Asist =
            regionOptions.find(
              (region) => region.value === service.Region_entrega_Cuideo_Asist
            ) ?? null;
        }
        if (service.Area_entrega_Cuideo_Asist) {
          values.Area_entrega_Cuideo_Asist =
            areaOptions.find(
              (area) => area.value === service.Area_entrega_Cuideo_Asist
            ) ?? null;
        }
      }
    }

    if (service.Inicio_de_servicio) {
      const date = moment(values.Inicio_de_servicio);
      if (date.isValid()) {
        values.Inicio_de_servicio = date.toDate();
      }
    }

    if (service.Tareas_solicitadas) {
      values.Tareas_solicitadas = tasksList().filter(
        (option) =>
          !!service.Tareas_solicitadas?.find((t) => t === option.value)
      );
    }

    if (service.Rutinas) {
      values.Rutinas = service.Rutinas;
    }

    if (service.Sexo_trabajador) {
      values.Sexo_trabajador = service.Sexo_trabajador;
    }

    if (service.Horario_Servicio) {
      values.Horario_Servicio = service.Horario_Servicio;
    } else if (service.Horario_servicio_venta) {
      values.Horario_Servicio = service.Horario_servicio_venta;
    }

    if (service.Fecha_inicio_servicio) {
      const date = moment(service.Fecha_inicio_servicio);
      if (date.isValid()) {
        values.Fecha_objetivo = date.toDate();
      }
    }

    if (service.Salario_Bruto) {
      values.Salario_Bruto = formatCurrency(service.Salario_Bruto).replace(
        /[^0-9.,]/g,
        ""
      );
    } else if (service.Salario_bruto_ventas) {
      values.Salario_Bruto = formatCurrency(
        service.Salario_bruto_ventas
      ).replace(/[^0-9.,]/g, "");
    }
    if (service.Tipo_de_salario) {
      values.Tipo_de_salario =
        salaryTypeOptions.find(
          (option) => option.value === service.Tipo_de_salario
        ) ?? null;
    }

    if (service.Fecha_objetivo_entrevistas) {
      const date = moment(service.Fecha_objetivo_entrevistas);
      if (date.isValid()) {
        values.Fecha_objetivo_entrevistas = date.toDate();
      }
    }

    if (service.Horas_jornada_semanal) {
      values.Horas_jornada_semanal = service.Horas_jornada_semanal + "";
    }
    if (service.Cl_usulas_especiales) {
      values.Cl_usulas_especiales = service.Cl_usulas_especiales;
    }
    if (service.Descanso_semanal) {
      values.Descanso_semanal = service.Descanso_semanal;
    }
    if (service.Titulaci_n_oficial) {
      values.Titulaci_n_oficial =
        officialDegreeOptions.find(
          (option) => option.value === service.Titulaci_n_oficial
        ) ?? null;
    }

    if (service.Usuario1?.relatedContacts) {
      service.Usuario1.relatedContacts.forEach((relationship) => {
        values.Contactos.push({
          id: relationship.id,
          contact_id: relationship.Contacto.id,
          contact_crm_id: relationship.Contacto.zohoId,
          Parentesco: relationship.Parentesco ?? "",
          Email: relationship.Contacto.Email ?? "",
          First_Name: relationship.Contacto.First_Name ?? "",
          Last_Name: relationship.Contacto.Last_Name ?? "",
          Phone: relationship.Contacto.Phone ?? "",
          op: "existing_relation",
        });
      });
    }

    if (service.customer) {
      const existingContact = values.Contactos.find(
        (relationship) => relationship.contact_id === service.customer?.id
      );
      if (existingContact) {
      } else {
        values.Contactos = [
          {
            id: uuidv4(),
            Email: service.customer.Email ?? "",
            First_Name: service.customer.First_Name ?? "",
            Last_Name: service.customer.Last_Name ?? "",
            Phone: service.customer.Phone ?? "",
            contact_id: service.customer.id,
            Parentesco: service.customer.Parentesco ?? "",
            op: "new_relation_existing_contact",
          },
          ...values.Contactos,
        ];
      }
    }

    if (service.Lead_External_ID) {
      values.Lead_External_ID = service.Lead_External_ID;
    }

    if (service.Referente_B2B) {
      values.Referente_B2B = {
        id: service.Referente_B2B.id,
      };
    }
  }

  return values;
};
